import { IValueViewModel } from '../../models';
import { VALUE_VIEW_MODELS_LOAD_SUCCESS, VALUE_VIEW_MODELS_LOAD, VALUE_VIEW_MODEL_LOAD_SUCCESS } from './valueViewModels.constants';

export function loadValueViewModels() {
    return { type: VALUE_VIEW_MODELS_LOAD };
}

export function loadValueViewModelsSuccess(data: IValueViewModel[]) {
    return { type: VALUE_VIEW_MODELS_LOAD_SUCCESS, payload: data };
}
export function loadValueViewModelSuccess(data: IValueViewModel) {
    return { type: VALUE_VIEW_MODEL_LOAD_SUCCESS, payload: data };
}